import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'menu-deep', 'MenuDeep', [["path",{"d":"M4 6h16"}],["path",{"d":"M7 12h13"}],["path",{"d":"M10 18h10"}]]);